import { render, staticRenderFns } from "./BoNews.vue?vue&type=template&id=540df518&"
import script from "./BoNews.vue?vue&type=script&lang=js&"
export * from "./BoNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports